module.exports = __webpack_public_path__ + "static/media/allow-not.1bb238e0.svg";